<template>
  <el-dropdown @visible-change="handleClick" trigger="click">
    <div class="el-dropdown-link">
      <img src="../../../assets/img/001.png" alt="" v-if="hove == false" />
      <img src="../../../assets/img/002.png" alt="" v-else />
    </div>
    <el-dropdown-menu slot="dropdown" style="height: 1200">
      <div class="colorthree"></div>
      <div id="war">
        <img :src="projackImg?projackImg:png" alt="" />
      </div>
      <div id="site" v-for="item in list.one" :key="item.id">
        <div class="site-one">
          <p class="one-item">{{ item.ip || ''}}</p>
          <p class="one-item-net">{{ item.arr }}{{ item.m }}</p>
        </div>
      </div>
      <div id="kong"></div>
      <ul id="arr">
        <li class="falx" v-for="item in list.two" :key="item.id">
          <p>{{ item.ip || ''}}</p>

          <p>{{ item.arr }}{{ item.m }}</p>
        </li>
      </ul>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import { chainIndex } from "../../../api/linkindex";
import { EnterpriseBackground } from "../../../api/backstageManagement";
import { play} from "../../../api/login";
export default {
  name: "Garden",
  data() {
    return {
      projackImg: "",
      center: "武汉市",
      itemarr: [],
      png:require('../../../assets/img/Nopng.png'),
      list: {
        one: [
            {
                id: 1,
                ip: "园区地址:",
                arr: [],
            },
            {
                id: 2,
                ip: "占地面积:",
                arr: [],
                m: "㎡",
            }
        ],
        two: [
            {
                id: 1,
                ip: "受电容量:",
                arr: [],
                m: "kVA",
            },
            {
                id: 2,
                ip: "电压等级:",
                arr: [],
                m: "kV",
            },
            {
                id: 3,
                ip: "供电来源:",
                arr: [],
            },
            {
                id: 4,
                ip: "地理位置:",
                arr: [],
            },
            {
                id: 5,
                ip: "供电公司:",
                arr: [],
            }
        ],
      },
      hove: false,
      id: "",
    };
  },
  mounted() {
    this.getall();
  },
  methods: {
    handleClick(t) {
      if (t) {
        this.hove = true;
      } else {
        this.hove = false;
      }
    },

    //渲染图片信息
    //渲染园区总览信息
    getall() {
      EnterpriseBackground.search().then((res) => {
    this.$set(this.list.one[0], 'arr',res.data.data.firm.firmAddress)

        play.currentProjectInfo().then((res) => {
            this.projackImg =  res.data.data.project.projectImg
          })
})

      chainIndex.bianyaqiAll(this.$store.state.project.currentProject.projectId).then((res=>{
    
        this.$set(this.list.two[0], 'arr',res.data.data.res ? res.data.data.res : "--",)
      }))
      chainIndex.getData(this.$store.state.project.currentProject.projectId).then((res) => {
         
        var mapjson = JSON.parse(res.data.data.project.projectDetailsInfo);
        // var 
    //    console.log(res.data.data.project.projectDetailsInfo,mapjson) 
        this.$set(this.list.one[1], 'arr',res.data.data.project.projectArea
            ? res.data.data.project.projectArea
            : "--")
        
        this.$set(this.list.two[1], 'arr', mapjson["供电电压"] ? mapjson["供电电压"] : "--")
        this.$set(this.list.two[2], 'arr', mapjson["供电来源: "] ? mapjson["供电来源: "] : "--")
        this.$set(this.list.two[3], 'arr',mapjson["地理位置: "] ? mapjson["地理位置: "] : "--")
        this.$set(this.list.two[4], 'arr', mapjson["管辖单位: "] ? mapjson["管辖单位: "] : "--")
        this.$emit("arrshow", this.list.two[0].arr);
        //存进vueX首页调用
        this.$store.commit("allip", {
          ip: this.list.two[0].arr,
          dis: this.list.two[1].arr,
        });
      });

    
    },
  },
};
</script>
<style lang="less" scoped>
.el-dropdown-menu {
  .w(528);
  .h(608);
  background: #ffffff;
  position: fixed !important;
  box-shadow: 0rem 4rem 40rem 0rem rgba(0, 43, 102, 0.28);
  left: 71% !important;
  top: 18% !important;
}
#war {
  .w(490);
  .h(276);
  // background-color: red;
  margin-bottom: 10rem;
  margin-left: 20rem;
  img {
    width: 100%;
    height: 100%;
  }
}
#site {
  font-size: 18rem;
  color: #333333;
  padding-left: 20rem;
  font-weight: 400;
  .site-one {
    display: flex;
    margin-bottom: 5rem;
    white-space: nowrap;
    .one-item {
      white-space: nowrap;
      width: 200rem;
      flex: 1;
      font-size: 18rem;
    }
    .one-item-net {
      white-space: nowrap;
      .w(359);
      padding-right: 10rem;
      flex: 4.5;
      font-size: 18rem;
    }
  }
}
#kong {
  border-bottom: 1rem solid #000000;
  opacity: 0.15;
}
#arr {
  padding: 13rem 0 0 24rem;
  background-color: #fff;
  padding-right: 30rem;
  .falx {
    margin-bottom: 10rem;
    display: flex;
    // white-space: nowrap;
    font-size: 18rem;
    color: #333333;
    // word-break:normal;
    // white-space:pre-warp;
    // word-wrap:break-word;
    // white-space: nowrap;
    p:first-child {
      display: flex;
      white-space: nowrap;
    }
    p:last-child {
      //  white-space: nowrap;
      display: flex;
      margin-left: 25rem;
    }
  }
}
::v-deep .el-dropdown-link:focus {
  outline: none;
}
.el-dropdown-link {
  width: 20rem;
  height: 20rem;
  cursor: pointer;
  position: relative;
  left: 100%;
  top: 2%;
}
.map {
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0;
  font-family: "微软雅黑";
}
.colorthree {
  position: absolute;
  width: 0;
  height: 0;
  border: 5rem solid;
  border-color: transparent transparent #fff;
  top: -10rem;
  left: 45%;
}
</style>